import { heartbeatActions as messages } from "../common/messages";
import { heartbeatActions as owners } from "../common/owners";
import { heartbeatActions as threads  } from "../common/threads";
import { heartbeatActions as owner_groups } from "../common/owner_groups";
import { heartbeatActions as owner_users } from "../common/owner_users";

const ADD = {
  messages: messages.add,
  owners: owners.add,
  message_threads: threads.add,
  owner_users: owner_users.add,
  owner_groups: owner_groups.add,
}

function main(dispatch, data) {
  if (!data) return

  for (let slice in ADD)
    if (data[slice])
      dispatch(ADD[slice](data[slice]))
}

export default main